﻿<template>
  <PmwParagraph size="paragraph-40" weight="light" class="check-item">
    <slot />

    <Icon v-if="checked" :icon="'check-circle'" class="check-item--icon" />
    <span v-else class="check-item--empty">-</span>
  </PmwParagraph>
</template>

<script>
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'ResumeCheckItem',

  components: {
    PmwParagraph
  },

  props: {
    checked: Boolean
  }
}
</script>

<style lang="scss" scoped>
.check-item {
  &--empty {
    display: inline-block;
    margin-left: pmw-space();
    font-size: 20px;
    vertical-align: middle;
  }

  & + & {
    margin-top: pmw-space();
  }

  &--icon {
    width: 14px;
    margin-left: pmw-space(0.5);
    fill: pmw-colors('blue-100');
  }
}
</style>
